"use client";
import { Input } from "@/components/ui/input";
import { useDebouncedCallback } from "use-debounce";
import { useState, useEffect } from "react";

type Props = {
  value: string;
  onChange: (val: string) => void;
  placeholder?: string;
  disabled?: boolean;
  customWidth?: string; // Add this
};

export function SearchBar({
  value,
  onChange,
  placeholder = "Search publications…",
  disabled = false,
  customWidth, // Add this
}: Props) {
  const [localValue, setLocalValue] = useState(value);

  // keep local state in sync when parent resets search
  useEffect(() => {
    setLocalValue(value);
  }, [value]);

  const debounced = useDebouncedCallback((v: string) => {
    onChange(v);
  }, 400);

  return (
    <div
      className="relative mr-2 max-h-[45px]"
      style={{ width: customWidth || "100%" }} // Update this
    >
      <Input
        value={localValue}
        onChange={(e) => {
          const v = e.target.value;
          setLocalValue(v); // instant update → no lag in typing
          debounced(v); // trigger query update after debounce
        }}
        placeholder={placeholder}
        variant="search"
        disabled={disabled}
      />
    </div>
  );
}
